import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=3f986ed2&"
import script from "./InvoicesTable.vue?vue&type=script&lang=ts&"
export * from "./InvoicesTable.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&id=3f986ed2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports